"use client";

import { motion } from "framer-motion";
import { Badge } from "@/components/ui/Badge";
import { landingContent } from "@/content/landing";

const heroIcon = (name: string) => `/assets/hero-icons/${name}.svg`;

function BadgeMaskIcon({ name }: { name: string }) {
  return (
    <span
      aria-hidden="true"
      className="block size-[20px] bg-white"
      style={{
        WebkitMaskImage: `url(${heroIcon(name)})`,
        maskImage: `url(${heroIcon(name)})`,
        WebkitMaskRepeat: "no-repeat",
        maskRepeat: "no-repeat",
        WebkitMaskPosition: "center",
        maskPosition: "center",
        WebkitMaskSize: "contain",
        maskSize: "contain",
      }}
    />
  );
}

/** Standard landing hero chips. The parent must be the 600px upload-card wrapper. */
export function HeroFloatingBadges({ labels }: { labels?: readonly string[] }) {
  const badges = landingContent.hero.badges.map((badge, index) => ({
    ...badge,
    label: labels?.[index] ?? badge.label,
  }));

  return (
    <>
      {badges.map((badge) => (
        <div
          key={badge.label}
          className="absolute hidden items-center justify-center desktop:flex"
          style={{
            left: `calc(50% + ${badge.left}px)`,
            top: badge.top,
            transform: "translateX(-50%)",
          }}
        >
          <motion.div
            style={{ transform: `rotate(${badge.rotate}deg)` }}
            whileHover={{ rotate: badge.rotate > 0 ? 3 : -3, scale: 1.08 }}
            transition={{ type: "spring", stiffness: 300, damping: 12 }}
          >
            <Badge
              label={badge.label}
              icon={<BadgeMaskIcon name={badge.icon} />}
              color={badge.color}
            />
          </motion.div>
        </div>
      ))}
    </>
  );
}
